import { CommonModule } from "@angular/common";
import { Component } from '@angular/core';
import { SvgIconComponent } from "angular-svg-icon";
import { XIconButtonComponent } from "../x-icon-button/x-icon-button.component";

@Component({
  selector: 'app-x-icon-button-selector',
  standalone: true,
  imports: [
    CommonModule,
    SvgIconComponent,
    XIconButtonComponent
],
  templateUrl: './x-icon-button-selector.component.html',
  styleUrl: './x-icon-button-selector.component.less',
})
export class XIconButtonSelectorComponent { }
